import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class ControleHabilitacaoCamposService {

    // Obs.: ser passivel de retificacao ou aditivo nao significa necessariamente que a alteracao sera permitida (isso eh validado pelo backend)
    // isto serve apenas para o front habilitar ou nao o campo para o usuario
    
    // Modalidades nao explicitamente configuradas seguirão o que estiver configurado para o curinga ModalidadeGarantia.OUTRA

    controleHabilitacao: ControleHabilitacao[] = [];

    public passivelDeRetificacao(nomeCampo: string, codigoModalidade: string): boolean {
 
        const controleCampo = this.controleHabilitacao.find((controle) => controle.campo === nomeCampo);
        if (controleCampo === undefined) {
            console.log("Atencao! Campo desconhecido: " + nomeCampo + ". Nao eh possivel saber se o mesmo eh passivel de ser"
              + " retificado. Verifique a configuracao de habilitacao realizada. Assumindo valor false.");
            return false;
        }

        if (codigoModalidade === undefined) {
            console.log("Modalidade nao especificada na determinacao de habilitacao de campo.");
          return false;
        }
       
        return controleCampo.passivelRetificacao.includes(codigoModalidade);
    }

    public passivelDeAditivo(nomeCampo: string, codigoModalidade: string): boolean {
       
        const controleCampo = this.controleHabilitacao.find((controle) => controle.campo === nomeCampo);
        if (controleCampo === undefined) {
            console.log('Atencao! Campo desconhecido: ' + nomeCampo + '. Nao eh possivel saber se o mesmo eh passivel de ser'
              + ' aditado. Verifique a configuracao de habilitacao realizada. Assumindo valor false.');
            return false;
        }

        if (codigoModalidade === undefined) {
            console.log("Modalidade nao especificada na determinacao de habilitacao de campo.");
          return false;
        }
        
        return controleCampo.passivelAditivo.includes(codigoModalidade);
    }  

    public setControleHabilitacao(controleHabilitacao: ControleHabilitacao[]) {
      this.controleHabilitacao = controleHabilitacao;
    }
}

export class ControleHabilitacao {
    campo: string;
    passivelRetificacao: string[];
    passivelAditivo: string[];
}
